import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardFooter,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Link,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import { renderImgFromAssets, goToBack } from "../common/UtilityHelper";
import { setT1T2ProductDataRequest } from "../actions/TaxonomyActions";
import AppHeader from "./AppHeader";
import auth from "./Security/Auth";
import { UIServerURL } from "./GlobalSettings";
import ShareContentMessage from "./ShareContentMessage";

class TaxonomyL2 extends Component {
  constructor(props) {
    super(props);
    // console.log("Get FIle Names: ", getFileNames());
    this.state = {
      bIsShared: false,
      TxL2Url: undefined,
    };

    this.OnLink = this.OnLink.bind(this);
    this._hideShareContentPopUp = this._hideShareContentPopUp.bind(this);
  }

  componentDidMount() {
    document.body.style.overflow = "hidden";
    console.log("Props for L2 Taxonomy comes as  ", this.props);
    if (
      !this.props.currentTaxonomyL2Data ||
      this.props.currentTaxonomyL2Data.length === 0
    ) {
      this.props.history.push("/home");
    }
  }

  _HandleT2DeepLinkCat() {
    var TaxonomyLevel2Data = this.props.currentTaxonomyL2Data.TaxonomyItems;
    var T2Param = auth.getT2CategoryParam();
    var L2Dt = TaxonomyLevel2Data.filter((ll2) => {
      return ll2.Taxonomy_Name === T2Param;
    });
    console.log(
      " Inside T2 HandleT2DeepLinkCat - Matched L2 Category Data  as per Deep Link T1 is ",
      L2Dt[0],
    );

    if (L2Dt && L2Dt.length > 0) {
      auth.removeT2CategoryParam();
      this.onTaxonomyL2CardClick(L2Dt[0]);
    }
  }

  OnLink(selectedTaxL1Name, selectedTaxL2Name) {
    console.log(
      "Link btn clicked to create for Tax Level 1 deeplink URL - " +
        selectedTaxL1Name +
        " and Tax L2 " +
        selectedTaxL2Name,
    );
    var lnk =
      UIServerURL +
      "?t1=" +
      encodeURIComponent(selectedTaxL1Name) +
      "&t2=" +
      encodeURIComponent(selectedTaxL2Name);
    this.setState({ TxL2Url: lnk, bIsShared: true });
  }

  _hideShareContentPopUp() {
    this.setState({ TxL2Url: undefined, bIsShared: false });
  }

  _HPEOnBackClick = () => {
    goToBack(this.props.history);
  };

  onHomeClick = () => {
    this.props.history.push("/home");
  };

  onTaxonomyL2CardClick = (selectedCardData) => {
    this.props.setT1T2ProductData(selectedCardData);
    if (selectedCardData && selectedCardData.Taxonomy_Name) {
      this.props.history.push("/t1t2products");
    }
  };

  render() {
    const { currentTaxonomyL2Data } = this.props;
    if (currentTaxonomyL2Data == null || currentTaxonomyL2Data == undefined) {
      this.props.history.push("/home");
    }
    const { Taxonomy_Name } = currentTaxonomyL2Data
      ? currentTaxonomyL2Data
      : "No Data - Please go back to Home";

    if (auth.getT2CategoryParam()) {
      console.log(
        "Taxonomy Level 2 Data is ",
        this.props.currentTaxonomyL2Data,
      );
      console.log(
        "Deep Link based T2 Category supplied is",
        auth.getT2CategoryParam(),
      );
      this._HandleT2DeepLinkCat();
    }

    var TxLnkUrl = this.state.bIsShared ? this.state.TxL2Url : null;
    var isTxDeepLink = this.state.bIsShared;

    return (
      <Box fill="vertical" align="stretch" justify="start">
        <Main
          overflow={{ vertical: "scroll" }}
          // background={{ image: "url('')" }}
          flex
          align="stretch"
          justify="start"
          margin={{ bottom: "xlarge" }}
        >
          {/* <AppHeader /> */}
          <Box
            align="stretch"
            justify="center"
            flex="grow"
            background={{ color: "background-back" }}
            direction="row"
          >
            <Box
              align="stretch"
              // overflow={{ vertical: "scroll" }}
              justify="start"
              flex="shrink"
              pad={{ horizontal: "large", vertical: "medium" }}
              gap="medium"
              basis="xlarge"
            >
              <Header
                align="start"
                direction="column"
                flex={false}
                justify="start"
                gap="xxsmall"
              >
                <Box align="center" justify="center" direction="row">
                  <Button
                    label=" Home"
                    icon={<FormPrevious />}
                    gap="xsmall"
                    onClick={this.onHomeClick}
                  />
                  <Button
                    label=" All demos"
                    icon={<FormPrevious />}
                    gap="xsmall"
                    onClick={this._HPEOnBackClick}
                  />
                </Box>
                <Heading margin="none">{Taxonomy_Name}</Heading>
              </Header>
              <Header
                align="center"
                direction="row"
                flex={false}
                justify="start"
                gap="medium"
              >
                {/*                 <Box
                  align="center"
                  justify="center"
                  direction="row"
                  gap="small"
                >
                  <TextInput icon={<Search />} placeholder="Search content" />
                </Box> */}
              </Header>
              <Box align="stretch" justify="center">
                {isTxDeepLink && TxLnkUrl && (
                  <ShareContentMessage
                    url={TxLnkUrl}
                    hide={this._hideShareContentPopUp}
                  />
                )}
                <Grid columns={{ size: "flex", count: 4 }} gap="small">
                  {currentTaxonomyL2Data &&
                    currentTaxonomyL2Data.TaxonomyItems &&
                    Array.isArray(currentTaxonomyL2Data.TaxonomyItems) &&
                    currentTaxonomyL2Data.TaxonomyItems.length &&
                    currentTaxonomyL2Data.TaxonomyItems.map((dataObj) => {
                      return (
                        <Card
                          key={dataObj.TaxonomyId}
                          justify="start"
                          gap="small"
                          // onClick={() => this.onTaxonomyL2CardClick(dataObj)}
                          hoverIndicator
                        >
                          <Box
                            align="start"
                            justify="start"
                            fill="horizontal"
                            //border={{ color: "brand", size: "medium" }}
                            // round="full"
                            background={{ color: "brand" }}
                            elevation="medium"
                            //animation={{ type: "jiggle", duration: 3000 }}
                            onClick={() => this.onTaxonomyL2CardClick(dataObj)}
                          >
                            <CardHeader
                              align="center"
                              direction="row"
                              flex={false}
                              justify="between"
                              gap="medium"
                              pad="small"
                              style={{ padding: "16px 12px" }}
                            >
                              <Heading margin="none" level="2" size="xsmall">
                                {dataObj.Taxonomy_Name}
                              </Heading>
                            </CardHeader>
                          </Box>
                          <CardBody pad="small">
                            {dataObj.MetaDataItems.map((metaObj) => {
                              return (
                                <Box
                                  align="start"
                                  justify="start"
                                  fill="horizontal"
                                  //border={{ color: "brand", size: "medium" }}
                                  // round="full"
                                  // background={{ color: "brand" }}
                                  // elevation="small"
                                  //animation={{ type: "jiggle", duration: 3000 }}
                                  onClick={() =>
                                    this.onTaxonomyL2CardClick(dataObj)
                                  }
                                >
                                  <Text color="text-strong">
                                    {metaObj.Metadata_Name}
                                  </Text>
                                </Box>
                              );
                            })}
                            {dataObj.Taxonomy_Name === "INTEL" &&
                              renderImgFromAssets("INTEL")}
                            {dataObj.Taxonomy_Name === "INTEL" &&
                              console.log("YES INTEL IT IS !!")}
                            {dataObj.Taxonomy_Name === "AMD" &&
                              renderImgFromAssets("AMD")}
                            {dataObj.Taxonomy_Name === "Nutanix" &&
                              renderImgFromAssets("NUTANIX")}
                            {dataObj.Taxonomy_Name === "INTEL" &&
                              console.log("YES AMD IT IS !!")}
                            {dataObj.Taxonomy_Name === "Microsoft" &&
                              renderImgFromAssets("MICROSOFT")}
                            {dataObj.Taxonomy_Name === "VMware" &&
                              renderImgFromAssets("VMWARE")}
                            {dataObj.Taxonomy_Name === "RedHat" &&
                              renderImgFromAssets("REDHAT")}
                            {dataObj.Taxonomy_Name === "NVIDIA" &&
                              renderImgFromAssets("NVIDIA")}
                            {dataObj.Taxonomy_Name === "SUSE" &&
                              renderImgFromAssets("SUSE")}
                            {dataObj.Taxonomy_Name === "Thales" &&
                              renderImgFromAssets("thales")}
                            {dataObj.Taxonomy_Name === "Catalogic" &&
                              renderImgFromAssets("cloudcasa")}
                          </CardBody>
                          <CardFooter pad="small">
                            <Box
                              align="start"
                              justify="start"
                              fill="horizontal"
                            >
                              <Button
                                icon={<Link color="brand" />}
                                hoverIndicator
                                tip={{
                                  dropProps: { align: { left: "right" } },
                                  content: "Copy Url to Clipboard",
                                }}
                                onClick={() =>
                                  this.OnLink(
                                    Taxonomy_Name,
                                    dataObj.Taxonomy_Name,
                                  )
                                }
                              />
                            </Box>
                            <Box align="end" justify="end" fill="horizontal">
                              <Box
                                align="center"
                                justify="center"
                                border={{ color: "brand", size: "medium" }}
                                round="full"
                                background={{ color: "brand" }}
                                elevation="small"
                                animation="pulse"
                                width="35px"
                                height="35px"
                                style={{ padding: "5px" }}
                              >
                                <Text color="white">
                                  {dataObj.Content_Count &&
                                  dataObj.Content_Count > 0
                                    ? dataObj.Content_Count
                                    : 0}
                                </Text>
                              </Box>
                            </Box>
                          </CardFooter>
                        </Card>
                      );
                    })}
                </Grid>
              </Box>
            </Box>
          </Box>
        </Main>
      </Box>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    currentTaxonomyL2Data: state.taxonomy.currentTaxonomyL2Data,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setT1T2ProductData: (data) => {
      dispatch(setT1T2ProductDataRequest(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TaxonomyL2);
